// src/pages/Dashboard.jsx
import React, { useLayoutEffect, useState } from 'react';
import Sidebar from '../components/dashboard/Sidebar';
import ReviewerPanel from '../components/dashboard/ReviewerPanel';
import LeadReviewerPanel from '../components/dashboard/LeadReviewerPanel';
import AssignmentsPanel from '../components/dashboard/AssignmentsPanel';
import '../styles/Dashboard.css';
import '../styles/Sidebar.css';

export default function Dashboard() {
  const user = JSON.parse(localStorage.getItem('user'));
  const [sizes, setSizes] = useState({ top: 56, bottom: 56 }); // defaults

  // Measure your real global header/footer heights (adjust selectors if needed)
  useLayoutEffect(() => {
    const header =
      document.querySelector('.global-header') ||
      document.querySelector('header');
    const footer =
      document.querySelector('.global-footer') ||
      document.querySelector('footer');

    setSizes({
      top: header ? header.getBoundingClientRect().height : 56,
      bottom: footer ? footer.getBoundingClientRect().height : 56,
    });
  }, []);



  if (!user) {
    return (
      <div style={{ padding: 24 }}>
        <h1>Dashboard</h1>
        <p>Please log in to access your dashboard.</p>
      </div>
    );
  }

  // Put CSS vars on the layout node (no computed keys → no ESLint warning)
  const cssVars = {
    '--rv-topbar-height': `${sizes.top}px`,
    '--rv-footer-height': `${sizes.bottom}px`,
    '--rv-sidebar-width': '240px',
  };

  return (
    <div className="dashboard-layout" style={cssVars}>
      <Sidebar />
      <main className="dashboard-main">
        {/* Tasks section for all users */}
        <div className="section" style={{ marginBottom: '2rem' }}>
          <AssignmentsPanel />
        </div>

        {/* Lead reviewers see the triage + assignment panel */}
        {user.role === 'lead_reviewer' && <LeadReviewerPanel />}

        {/* Reviewers see the review queue (only assigned items) */}
        {user.role === 'reviewer' && <ReviewerPanel />}


      </main>
    </div>
  );
}
